<template>
    <modal-jetstream :show="open" :max-width="'2xl'">
        <div class="rounded-md overflow-x-auto m-2">
            <div class="flex flex-col">
                <div class="overflow-x-auto">
                    <div class="align-middle inline-block min-w-full">
                        <div class="overflow-hidden bg-white ring-1 ring-gray-200 p-6 flex flex-col md:flex-row justify-between gap-6">
                            <!-- Left Section -->
                            <div class="space-y-4">
                                <h2 class="text-xl font-semibold text-gray-800">Experian Identity Verification Help?</h2>
                                <p class="text-gray-600">
                                    We use Experian to verify your identity securely.
                                    To avoid verification issues, please make sure to use your personal information — not business details.
                                </p>
                                <p class="text-gray-600">
                                    Here are a few tips to help you match what Experian has on file:
                                </p>
                                <ul class="list-disc pl-5 text-gray-600 space-y-1">
                                <li>Use your full legal last name (or maiden name if recently married).</li>
                                <li>Enter your most recent home address (not a business or PO Box address).</li>
                                <li>Provide the same personal information that appears on your credit history.</li>
                                </ul>
                                <p class="text-gray-600">
                                    Experian compares the information you provide against your credit profile.
                                </p>
                                <p class="text-gray-600">
                                    Using accurate, up-to-date personal details increases the chances of a smooth verification process.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <button @click="emit('update:open', false)" class="bg-white py-2 px-4 m-3 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 float-right">Close</button>
    </modal-jetstream>
</template>

<script setup>
import ModalJetstream from "@/Jetstream/Modal.vue";

const props = defineProps({
    open: Boolean,
});

const emit = defineEmits(['update:open']);
</script>
